import { render, staticRenderFns } from "./CurrencySelectInputWidget.vue?vue&type=template&id=3a9b838a&scoped=true"
import script from "./CurrencySelectInputWidget.vue?vue&type=script&lang=js"
export * from "./CurrencySelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b838a",
  null
  
)

export default component.exports